// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const READ_WHOLE_REVIEW = "\u010c\u00edtaj cel\u00e9...";
export const WIKI_EXP_GUEST_LABEL = "hos\u0165";
